import Box from '@material-ui/core/Box';
import { useTheme } from '@material-ui/core/styles';
import { generateDropdownOptions, isInsuracePortalUser } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

const Title = lazy(() => import('globalcomponents/Title'));
const Content = lazy(() => import('@/modules/TrailerManagement/Component'));

const AddTrailer = ({
  apiStatus,
  fetchTrailerData,
  fetchInsuranceTrailerData,
  fetchCompanyList,
  getDocumentToken,
  regions,
  trailer,
  clearReceipt,
  ...rest
}) => {
  const theme = useTheme();
  const i18n = useTranslation();

  const [disabledCriteria, setDisabledCriteria] = useState({
    regionId: false,
    terminalId: false,
    departmentId: false,
    subDepartmentId: false,
  });

  const fetchInsuraceTrailerDataApi = 'fetchInsuranceTrailerData';

  useEffect(() => {
    isInsuracePortalUser()
      ? fetchInsuranceTrailerData({ apiId: fetchInsuraceTrailerDataApi })
      : fetchTrailerData({ apiId: 'fetchTrailerData' });
    fetchCompanyList({ apiId: 'fetchFleetCompanies' });
    getDocumentToken({ apiId: 'getDocToken' });
    clearReceipt();
  }, []);

  useEffect(() => {
    if (trailer?.accessLevel !== undefined) {
      const criteria = {
        regionId: trailer.accessLevel < 4,
        terminalId: trailer.accessLevel < 3,
        departmentId: trailer.accessLevel < 2,
        subDepartmentId: trailer.accessLevel < 1,
      };
      setDisabledCriteria(criteria);
    }
  }, [trailer?.accessLevel]);

  const recallUpdate = useCallback(
    (company) => {
      fetchInsuranceTrailerData({
        apiId: fetchInsuraceTrailerDataApi,
        data: { company, recall: true },
      });
    },
    [fetchInsuranceTrailerData]
  );

  const getOptions = (list, fallbackList, labelKey, valueKey) => {
    const source = list?.length ? list : fallbackList;
    return generateDropdownOptions(source, labelKey, valueKey);
  };

  return (
    <>
      <Title header={i18n.t('trailers.addHeading')} i18n={i18n} />
      <Box style={{ ...theme.palette.contentStyle }}>
        <Content
          {...rest}
          apiStatus={apiStatus}
          recallUpdate={recallUpdate}
          regions={getOptions(
            isInsuracePortalUser() ? regions?.data?.regions : trailer.regions,
            trailer.regions,
            'regionName',
            'id'
          )}
          terminals={getOptions(regions?.data?.terminals, trailer.terminals, 'terminalName', 'terminalId')}
          departments={getOptions(regions?.data?.departments, trailer.departments, 'departmentName', 'departmentId')}
          subDepartments={getOptions(
            regions?.data?.subDepartments,
            trailer.subDepartments,
            'subDepartmentName',
            'subDepartmentId'
          )}
          disabledCriteria={disabledCriteria}
          trailer={trailer}
        />
      </Box>
    </>
  );
};

const mapState = (state) => ({
  apiStatus: state.asyncRequests,
  regions: state.regions,
  documents: state.documents,
  trailer: state.trailers,
  fleetCompanies: state.fleetCompanyList.companyList,
  logBook: state.logBook,
  receipt: state.viewReport,
});

const mapDispatch = (dispatch) => ({
  fetchTerminals: (data) => dispatch.regions.fetchTerminals(data),
  fetchDepartments: (data) => dispatch.regions.fetchDepartments(data),
  fetchSubDepartments: (data) => dispatch.regions.fetchSubDepartments(data),
  fetchTrailerData: (data) => dispatch.trailers.fetchData(data),
  saveTrailerData: (data) => dispatch.trailers.saveData(data),
  fetchInsuranceTrailerData: (data) => dispatch.trailers.fetchInsuranceData(data),
  getRegions: (data) => dispatch.regions.fetchRegionsByCompany(data),
  fetchCompanyList: (data) => dispatch.fleetCompanyList.fetchCompanyList(data),
  isValidVin: (data) => dispatch.trailers.isValidVin(data),
  saveDocument: (data) => dispatch.trailers.saveDocument(data),
  deleteDocument: (data) => dispatch.trailers.deleteDocument(data),
  getDocumentToken: (data) => dispatch.logBook.documentToken(data),
  downloadDocument: (data) => dispatch.viewReport.downloadReport(data),
  clearReceipt: () => dispatch.viewReport.clearReceipt(),
});

AddTrailer.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  fetchTrailerData: PropTypes.func.isRequired,
  fetchInsuranceTrailerData: PropTypes.func.isRequired,
  fetchCompanyList: PropTypes.func.isRequired,
  getDocumentToken: PropTypes.func.isRequired,
  clearReceipt: PropTypes.func.isRequired,
  regions: PropTypes.object,
  trailer: PropTypes.object,
};

export default connect(mapState, mapDispatch)(AddTrailer);
